import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';
import { LegalModal } from '../LegalModal';
import { CONTACT_EMAIL, privacyPolicy, termsAndConditions } from '../../data/legal';
import type { LegalDocument } from '../../data/legal';
export function Closing() {
  const [activeDoc, setActiveDoc] = useState<LegalDocument | null>(null);
  return <footer className="w-full bg-white" data-id="element-53" data-mp="1cp82aouc6fro">
      <div className="mx-auto max-w-2xl px-5 py-14 text-center sm:px-8 sm:py-16" data-id="element-54" data-mp="17q4xn5i9qbk8">
        <Reveal data-id="element-55" data-mp="12zogpbf8o7t4">
          <p className="font-serif text-xl italic leading-relaxed text-ink sm:text-2xl" data-id="element-56" data-mp="12z6cnsmc4pan">
            La energía estable no es un lujo. Es tu derecho biológico.
          </p>
          <p className="mt-3 font-serif text-xl font-semibold italic text-forest sm:text-2xl" data-id="element-57" data-mp="xy8tbcpl9p7k">
            Reclámalo hoy.
          </p>
        </Reveal>
      </div>

      <div className="border-t border-mist bg-mist" data-id="element-58" data-mp="ozdp2663up6w">
        <div className="mx-auto max-w-container px-5 py-10 sm:px-8 sm:py-12" data-id="element-59" data-mp="k12hy3772ssd">
          <nav aria-label="Legal" className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-60" data-mp="k36jiehmffph">
            <button type="button" onClick={() => setActiveDoc(privacyPolicy)} className="text-sm font-semibold text-forest underline-offset-4 transition-colors duration-200 ease-smooth hover:text-gold hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-61" data-mp="1kxfkfuy6szho">
              Políticas de Privacidad
            </button>
            <button type="button" onClick={() => setActiveDoc(termsAndConditions)} className="text-sm font-semibold text-forest underline-offset-4 transition-colors duration-200 ease-smooth hover:text-gold hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-62" data-mp="23qjg1luytmex">
              Términos y Condiciones
            </button>
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-sm font-semibold text-forest underline-offset-4 transition-colors duration-200 ease-smooth hover:text-gold hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-63" data-mp="j8btcj982qw3">
              Soporte
            </a>
          </nav>

          <div className="mx-auto mt-8 max-w-3xl space-y-4 text-center text-[0.7rem] leading-relaxed text-faint" data-id="element-64" data-mp="2g8cbdfi2ewwc">
            <p data-id="element-65" data-mp="2c7af97jg30yl">
              <strong className="font-semibold text-muted" data-id="element-66" data-mp="2c5pjjele9bz5">Descargo de responsabilidad:</strong>{' '}
              este sitio no forma parte de Facebook, Instagram ni de Meta Platforms, Inc., y no
              está patrocinado, avalado ni administrado por ellos. FACEBOOK™ e INSTAGRAM™ son
              marcas registradas de Meta Platforms, Inc.
            </p>
            <p data-id="element-67" data-mp="1t7wheeilh62t">
              Método Glucosa Estable es un producto digital de carácter educativo. El contenido no
              constituye consejo médico, diagnóstico ni tratamiento y no sustituye la consulta con
              un profesional de la salud. Si estás embarazada, en lactancia, tomas medicación o
              tienes una condición metabólica, consulta a tu médico antes de aplicar cambios en tu
              alimentación.
            </p>
            <p data-id="element-68" data-mp="1eboj5xw44pjy">
              Los testimonios reflejan experiencias individuales y no constituyen una garantía de
              resultados. Los resultados varían según cada persona. Pago único, sin suscripciones
              ni cargos recurrentes; los precios se muestran en USD y la pasarela de pago realiza
              la conversión a moneda local antes de confirmar la compra.
            </p>
            <p data-id="element-69" data-mp="vex3rzjoyul6">
              Consultas y soporte:{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-muted underline-offset-4 transition-colors duration-200 ease-smooth hover:text-gold hover:underline" data-id="element-70" data-mp="zg8njofvwllg">
                {CONTACT_EMAIL}
              </a>
            </p>
            <p className="pt-2 text-muted" data-id="element-71" data-mp="2aum2u4wknspv">
              © {new Date().getFullYear()} Método Glucosa Estable. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>

      <LegalModal document={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-72" data-mp="2edl7eot0v71n" />
    </footer>;
}